import React from "react"
import {Alert, Button, Stack} from "@mui/material"

// Shown inside the Zendesk iframe when the Keycloak silent SSO check fails
// (no session, or the browser blocks third-party cookies). Interactive
// Keycloak login can't render inside an iframe, so we send the agent to a
// full Hermes tab and let them retry.
const ZendeskAuthHint = () => (
    <Stack spacing={1.5} sx={{p: 1.5}}>
        <Alert severity="info">
            Нужна авторизация в Hermes. Войдите в Hermes в отдельной вкладке, затем нажмите «Повторить».
        </Alert>
        <Button variant="contained" onClick={() => window.open(window.location.origin, "_blank")}>
            Открыть Hermes
        </Button>
        <Button variant="outlined" onClick={() => window.location.reload()}>
            Повторить
        </Button>
    </Stack>
)

export default ZendeskAuthHint
